import { gql } from '@apollo/client'
import { buildGraphqlQuery } from '@ztechapps/common.utils'

/** What saving a minted preview slug returns. */
export const blogPreviewSlugFragment = gql`
  fragment blogPreviewSlugFragment on Blog {
    _id
    updatedAt
    slug
  }
`
export const blogPreviewSlugQueries = buildGraphqlQuery('Blog', blogPreviewSlugFragment)
